import { render, staticRenderFns } from "./ViewModal.vue?vue&type=template&id=f85fa168&"
import script from "./ViewModal.vue?vue&type=script&lang=js&"
export * from "./ViewModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports